import React from 'react'

import { Modal } from 'common/components'
import { parseZoneFormat } from 'common/dateFormatters'

import './styles.less'

type OptOutConfirmModalProps = {
  visible: boolean
  maxDateToTakeBenefitParticipationDecision: string
  hasBenefitStarted: boolean
  onOk?: () => void
  onCancel?: () => void
  okButtonLoading?: boolean
  okButtonDisabled?: boolean
}

export default function OptOutConfirmModal({
  visible,
  maxDateToTakeBenefitParticipationDecision,
  hasBenefitStarted,
  onOk,
  onCancel,
  okButtonLoading,
  okButtonDisabled,
}: OptOutConfirmModalProps) {
  return (
    <>
      <Modal
        className={'opt-out-confirmation-modal'}
        visible={visible}
        title={'Are you sure you want to opt out?'}
        okText={'Yes, opt out'}
        onOk={onOk}
        okButtonProps={{ loading: okButtonLoading, disabled: okButtonDisabled }}
        onCancel={onCancel}
      >
        <p>If you opt-out of your ICHRA:</p>
        <ul>
          <li>You won’t be eligible for expense reimbursements through the benefit.</li>
          <li>
            You may not be eligible for premium tax credits (subsidies) on your insurance if your ICHRA allowance is
            considered “affordable” by the federal government.
          </li>
          {!hasBenefitStarted && (
            <li>
              You can change your mind and opt in any time before{' '}
              {parseZoneFormat(maxDateToTakeBenefitParticipationDecision)}.
            </li>
          )}
        </ul>
      </Modal>
    </>
  )
}
